import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { DashboardHeader } from './components/dashboard/DashboardHeader';
import { ToolsSection } from './components/dashboard/ToolsSection';
import { WelcomeBackPromo } from './components/dashboard/WelcomeBackPromo';
import { MyGroupsWidget } from './components/dashboard/MyGroupsWidget';
import { SuccessHubWidget } from './components/dashboard/SuccessHubWidget';
interface DashboardContext {
  toggleMobileSidebar: () => void;
}
export function App() {
  const navigate = useNavigate();
  const {
    toggleMobileSidebar
  } = useOutletContext<DashboardContext>() || {
    toggleMobileSidebar: () => {}
  };
  // Mock data - in a real app this would come from the user's subscription/plan
  const userCategories = ['Business', 'HR'];
  const handleNavigateToAICopilot = () => {
    navigate('/ai-copilot');
  };
  const handleNavigate = (path: string) => {
    navigate(path);
  };
  return <>
      <DashboardHeader categories={userCategories} onMenuClick={toggleMobileSidebar} onNavigateToAICopilot={handleNavigateToAICopilot} onNavigate={handleNavigate} data-id="element-0" />
      <main className="p-3 sm:p-4 lg:p-6" data-id="element-1">
        <WelcomeBackPromo data-id="element-2" />
        <div className="grid grid-cols-1 gap-4 sm:gap-6 mb-4 sm:mb-6" data-id="element-3">
          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm" data-id="element-4">
            <ToolsSection data-id="element-5" />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6" data-id="element-6">
            <MyGroupsWidget data-id="element-7" />
            <SuccessHubWidget data-id="element-8" />
          </div>
        </div>
      </main>
    </>;
}